var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],staticClass:"w-full form-field",domProps:{"value":(_vm.answer)},on:{"input":function($event){if($event.target.composing)return;_vm.answer=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }